export const WALLET_SUBSCRIPTION_ACTIVE_MESSAGE = 'This organization already has an active wallet subscription.';
const FALLBACK_ERROR = 'Could not start the payment. Please try again.';

export type WalletIntentResult =
  | { kind: 'intent'; details: Record<string, any> }
  | { kind: 'alreadyActive'; message: string }
  | { kind: 'error'; message: string };

/**
 * Reads a `createInitiateWalletIntent` response ({ data, errors }). The backend returns `null`
 * with no error when the subscription is already active; otherwise the intent is base64 JSON.
 */
export function readWalletIntentResponse(response: any): WalletIntentResult {
  if (response?.errors?.length) {
    return { kind: 'error', message: response.errors[0]?.message || FALLBACK_ERROR };
  }
  const encoded = response?.data?.createInitiateWalletIntent;
  if (encoded == null || encoded === '') {
    return { kind: 'alreadyActive', message: WALLET_SUBSCRIPTION_ACTIVE_MESSAGE };
  }
  try {
    return { kind: 'intent', details: JSON.parse(atob(encoded)) };
  } catch {
    return { kind: 'error', message: FALLBACK_ERROR };
  }
}
